// Williams College's majors (#2740). Read on 2026-10-01 from the official
// Williams College Catalog, Courses & Programs 2026-27 (catalog.williams.edu):
// every program the listing marks "(major)", including Environmental Studies
// (major and concentration) and the Contract Major, the student-designed
// interdisciplinary major. Williams awards the Bachelor of Arts (Degree
// Requirements page). Concentrations, the course clusters the catalog calls
// Coordinates, and the graduate program in the history of art are left out.
const majors = {
    "slug": "williams-college",
    "read": "2026-10-01",
    "intro": "Every major in Williams' official 2026-27 Catalog, each leading to the Bachelor of Arts. Concentrations and graduate programs are left out.",
    "groups": [
        {
            "name": "Majors",
            "source": {
                "label": "Williams College Catalog, Courses & Programs 2026-27",
                "url": "https://catalog.williams.edu/2627/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Arabic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art Studio",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.A."
                },
                {
                    "name": "Astrophysics",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chinese",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Contract Major",
                    "degree": "B.A."
                },
                {
                    "name": "East Asian Languages & Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Economy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Women's, Gender & Sexuality Studies",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
